module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/about/melanie_peake.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/about/melanie_peake.jpg
// module id = fQZo
// module chunks = 0